import { Select } from "antd";
import { debounce } from "lodash";
import React, { useCallback, useState } from "react";
import { getPlacesByName } from "services/SauceService";

const LocationField: React.FC<any> = (props) => {
  const { onChange, value } = props;

  const [loadingLocation, setLoadingLocation] = useState<boolean>(false);
  const [places, setPlaces] = useState<any[]>([]);

  const getLocation = useCallback(async (locationName: string) => {
    setLoadingLocation(true);
    const response: any = await getPlacesByName({ name: locationName });
    setPlaces(
      response.map((place: any) => ({
        value: place.place_id,
        label: place.name,
        ...place,
      }))
    );
    setLoadingLocation(false);
  }, []);

  const handleSearch = (newValue: string) => {
    if (newValue) getLocation(newValue);
  };

  const handleChange = (selectedValue: string | undefined, option: any) => {
    if (!selectedValue) {
      onChange?.(undefined);
      return;
    }
    onChange?.({
      latitude: option?.geometry?.location?.lat,
      longitude: option?.geometry?.location?.lng,
      maxMilesDistance: 30,
      name: option?.name,
      place_id: option?.place_id,
    });
  };

  return (
    <div>
      <Select
        placeholder="Typing the name and address"
        showSearch
        filterOption={false}
        onSearch={debounce(handleSearch, 500)}
        onChange={handleChange}
        options={places}
        loading={loadingLocation}
        allowClear
        value={value?.place_id}
        getPopupContainer={(node) =>
          (node && node.parentElement) || document.body
        }
        optionRender={(option: any) => {
          return (
            <>
              <div style={{ padding: "8px", cursor: "pointer" }}>
                {`${option.data.name} - ${option.data.formatted_address}`}
              </div>
            </>
          );
        }}
      />
    </div>
  );
};

export default LocationField;
